jQuery(function ($) {
  if ($('.sivananda-page').hasClass('with-sidebar')) {
    $('.wp-block-sivananda-blocks-quotes .container').width($('.sivananda-page main').width());
  }

  setTimeout(() => {
    var swiper = new Swiper(".quotes-slider", {
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
    });
  }, 500);
});